import { StateStoring } from 'devextreme-react/data-grid';
import { useMemo } from 'react';
import {
  createOpsGridStateStoringProps,
  type OpsGridStateStorageOptions
} from './opsGridStateStorage';

export type OpsGridStateStoringProps = OpsGridStateStorageOptions;

/** Schema-versioned grid state persistence with column/filter sanitization. */
export function OpsGridStateStoring({ storageKey, schemaVersion, columns }: OpsGridStateStoringProps) {
  const props = useMemo(
    () => createOpsGridStateStoringProps({ storageKey, schemaVersion, columns }),
    [storageKey, schemaVersion, columns]
  );
  return <StateStoring {...props} />;
}
